/*
    Danger!
    You should not remove any comments from this file, if comments will be removed generator will be broken
*/

// __generator_imports__
import retargetingAudienceRoute from './retargeting-audience'
import retargetingAttributionRoute from './retargeting-attribution'
import partnerCategoriesRoute from './partner-categories'
import linksGeneratorWorkflowRoute from './links-generator-workflow'
import generatedLinksRoute from './generated-links'
import budgetRequestsLogRoute from './budget-requests-log'
import advertisersCostRoute from './advertisers-cost'
import advertisersRoute from './advertisers'
import budgetPlannerRoute from "@/router/generated-routes/budget-planner";
import budgetPlanRoute from './budget-plan'
import clicksRoute from './clicks'
import cohortAnalysisRoute from "./cohort-analysis";
import costsReportRoute from './costs-report'
import countryRoute from './country'
import cpaRsPerformanceReportRoute from './cpa-rs-performance-report'
import currenciesRoute from './currencies'
import dashboardRoute from './dashboard'
import eventsRoute from './events'
import generalReportRoute from './general-report'
import landingsRoute from './landings'
import newStreamsRoute from './new-streams'
import offerPartnersRoute from './offer-partners'
import offerRoute from './offer'
import partnerGroupsRoute from './partner-groups'
import partnerReportRoute from './partner-report'
import partnersRoute from './partners'
import partnersSpendsRoute from './partners-spends'
import paymentInvoicesRoute from './payment-invoices'
import soloPaymentInvoicesRoute from './solo-payment-invoices'
import paymentModelsRoute from './payment-models'
import playersReportsApiRoute from './players-reports-api';
import playersRoute from './players'
import postbacksRoute from './postbacks'
import productsRoute from './products'
import rolesRoute from './roles'
import settingsRoute from "@/router/generated-routes/settings";
import spendsParsingLogRoute from './spends-parsing-log'
import trafficSourcesRoute from './traffic-sources'
import usersRoute from './users'
import entityLogRoute from './entity-log'
import partnerSpendLogRoute from './partner-spend-log'

const routes = [
  // __imported_entities__
  ...retargetingAudienceRoute,
  ...retargetingAttributionRoute,
  ...partnerCategoriesRoute,
  ...linksGeneratorWorkflowRoute,
  ...generatedLinksRoute,
  ...budgetRequestsLogRoute,
  ...advertisersCostRoute,
  ...advertisersRoute,
  ...budgetPlannerRoute,
  ...budgetPlanRoute,
  ...clicksRoute,
  ...cohortAnalysisRoute,
  ...costsReportRoute,
  ...countryRoute,
  ...cpaRsPerformanceReportRoute,
  ...currenciesRoute,
  ...dashboardRoute,
  ...eventsRoute,
  ...generalReportRoute,
  ...landingsRoute,
  ...newStreamsRoute,
  ...offerPartnersRoute,
  ...offerRoute,
  ...partnerGroupsRoute,
  ...partnerReportRoute,
  ...partnersRoute,
  ...partnersSpendsRoute,
  ...paymentInvoicesRoute,
  ...soloPaymentInvoicesRoute,
  ...paymentModelsRoute,
  ...playersReportsApiRoute,
  ...playersRoute,
  ...postbacksRoute,
  ...productsRoute,
  ...rolesRoute,
  ...settingsRoute,
  ...spendsParsingLogRoute,
  ...trafficSourcesRoute,
  ...usersRoute,
  ...entityLogRoute,
  ...partnerSpendLogRoute,
]

export default routes
